import React, { useState } from 'react';
import { CardBody,  Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { connect } from "react-redux";

import { useForm } from "react-hook-form";
import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";
import {FL_POINT_A, FL_POINT_B} from "../../../components/i18n/formLabels";
import SelectGeneric from "../../../components/select/selectGeneric";
import {setFilter} from "../../../redux/actions/generalActions/listActions";
import {pointProvider} from "../../../providers/pointProvider";

const VectorFilters = props => {
    const { filter } = props.listProps
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id

    const [pointA, setPointA] = useState(filter?.pointA?.id);
    const [pointB, setPointB] = useState(filter?.pointB?.id);

    const [resetValue, setResetvalue] = useState(false)
    const { handleSubmit, reset} = useForm({
        defaultValues:{

        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase : { id : fbDataBaseId },
            item :  { }
        };

        if (pointA !== undefined && pointA !== null )
            dataFilter.item.pointA = { id : pointA };

        if (pointB !== undefined && pointB !== null )
            dataFilter.item.pointB = { id : pointB };

        props.setFilter(dataFilter);
    };

    const cleanFields = () => {
        setPointA(null);
        setPointB(null);
        setResetvalue(!resetValue);
        props.setFilter({
            fbDataBase : { id : fbDataBaseId },
            item : {  }
        });
        reset();
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_POINT_A }</Label>
                            <SelectGeneric
                                initialValue={ pointA }
                                setExternalValue={ value => setPointA( value ) }
                                isDisabled={ false }
                                provider = { pointProvider }
                                resetValue={ resetValue }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_POINT_B }</Label>
                            <SelectGeneric
                                initialValue={ pointB }
                                setExternalValue={ value => setPointB( value ) }
                                isDisabled={ false }
                                provider = { pointProvider }
                                resetValue={ resetValue }
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(VectorFilters)